// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33qXM","type":"styles_type__17LN7","choices":"styles_choices__3zvr4"};